import React from 'react';
import LayoutBuilder from './layoutbuilder';


export default () => {
  return (<div>
      <LayoutBuilder />
    </div>);
};
